<mat-button-toggle-group [value]="value" (change)="optionSelected($event)">
  <mat-button-toggle value="balanced" i18n>BALANCED</mat-button-toggle>
  <mat-button-toggle value="unbalanced" i18n>UNBALANCED</mat-button-toggle>
</mat-button-toggle-group>
